module.exports = __webpack_public_path__ + "img/partner14.ab01a486.png";